import api from '@/services/api'
import store from '../index'

export default {
  state: {},

  mutations: {},

  actions: {
    async getPlans({ commit }, classification) {
      try {
        const response = await api.get(
          `/plans?classification=${classification}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getPlansClient({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/plans`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
